import type { SimulationResponseInterface } from './types';
import { SIMULATION_RESULT, SIMULATE } from './types';

export interface SimulationRequestActionInterface {
  [extraProps: string]: unknown;
  type: typeof SIMULATE;
  payload: {
    autoSimulate: boolean;
    onSuccess?: () => void;
  };
}
export function simulationRequest(
  autoSimulate = true,
  onSuccess: SimulationRequestActionInterface['payload']['onSuccess'] = undefined,
): SimulationRequestActionInterface {
  return {
    type: SIMULATE,
    payload: {
      autoSimulate,
      onSuccess,
    },
  };
}
export interface SimulationResponseActionInterface {
  [extraProps: string]: unknown;
  type: typeof SIMULATION_RESULT;
  payload: SimulationResponseInterface;
}

export function setSimulationResult(
  simulationResult: SimulationResponseInterface,
): SimulationResponseActionInterface {
  return {
    type: SIMULATION_RESULT,
    payload: simulationResult,
  };
}

setSimulationResult.type = SIMULATION_RESULT;
